import PropTypes from 'prop-types'

const LoopIcon = ({ className }: { className: string }) => (
  <svg width={48} height={48} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" className={className}>
    <title>{'Builder/ Operation/ Loop'}</title>
    <g fill="#1A56DB" fillRule="nonzero">
      <path d="M14.71 5.293A1 1 0 0013.003 6v4.05C5.485 10.585-.26 16.977.01 24.509.28 32.04 6.466 38.006 14.003 38h4a2 2 0 000-4h-4c-5.523 0-10-4.477-10-10s4.477-10 10-10h7a1 1 0 00.707-1.707l-7-7zM34.003 10h-4a2 2 0 000 4h4c5.523 0 10 4.477 10 10s-4.477 10-10 10h-7a1 1 0 00-.707 1.707l7 7A1 1 0 0035.003 42v-4.051c7.518-.533 13.264-6.925 12.994-14.457C47.727 15.959 41.54 9.994 34.003 10z" />
    </g>
  </svg>
)

LoopIcon.displayName = 'LoopIcon'

LoopIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string
}

LoopIcon.defaultProps = {
  className: '',
  onClick: () => {},
  title: 'App Builder'
}

export default LoopIcon
